export const RegistryComponentNames = {
  AssetPopupContent: 'app-asset-popup-content',
  DriverPopupContent: 'app-driver-popup-content',
  LocationPopupContent: 'app-location-popup-content',
  POiPopupContent: 'app-poi-popup-content',
};
